import script from "./MainPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./MainPage2.vue?vue&type=script&setup=true&lang=js"

import "./MainPage2.vue?vue&type=style&index=0&id=b847000a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b847000a"]])

export default __exports__